/**
 * Theme definition following https://github.com/markdalgleish/react-themeable
 * for https://github.com/moroshko/react-autosuggest#renderSuggestionsContainerProp#theme-optional
 * @type {{container: string, containerOpen: string, input: string, inputOpen: string, inputFocused: string, suggestionsContainer: string, suggestionsContainerOpen: string, suggestionsList: string, suggestion: string, suggestionFirst: string, suggestionHighlighted: string, sectionContainer: string, sectionContainerFirst: string, sectionTitle: string}}
 */

const searchTheme = {
  container: 'm-search-form',
  containerOpen: 'm-search-form--open',
  input: 'm-search-form__input',
  inputOpen: 'm-search-form__input--open',
  inputFocused: 'm-search-form__input--focused',
  suggestionsContainer: 'm-search-form__suggestions',
  suggestionsContainerOpen: 'm-search-form__suggestions--open',
  suggestionsList: 'm-search-form__suggestions-list',
  suggestion: 'm-search-form__suggestion',
  suggestionFirst: 'm-search-form__suggestion--first',
  suggestionHighlighted: 'm-search-form__suggestion--highlighted',
  sectionContainer: 'm-search-form__section-container',
  sectionContainerFirst: 'm-search-form__section-container--first',
  sectionTitle: 'm-search-form__section-title',
};

export default searchTheme;



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/SearchForm/searchTheme.jsx